import { useFormContext } from 'react-hook-form';

import { ProjectInputs } from 'src/global/types/project.type';

import { StepAccordion } from '../StepAccordion';
import { TierPricing } from './TierPricing';

export function PricingModel({ isDetail = false }: { isDetail?: boolean }) {
  const {
    formState: { errors },
  } = useFormContext<ProjectInputs>();
  return (
    <StepAccordion isError={!!errors.tier} index={4} title='Pricing Model' open={false}>
      <TierPricing isDisabled={isDetail} />
    </StepAccordion>
  );
}
